import { useCallback } from 'react';

import { useSectionNodesResizeHandlers } from '@/components/diagrams/FlowChart/nodes/SectionLabelNode/hooks';

import { EntityDiagramEffectFn, RecomputeSectionWidthsEffect } from '../types';

export function useRecomputeSectionWidthsEffect(): EntityDiagramEffectFn<RecomputeSectionWidthsEffect> {
  const { forceSectionNodesRelayout } = useSectionNodesResizeHandlers();

  return useCallback<EntityDiagramEffectFn<RecomputeSectionWidthsEffect>>(
    (state, _effect, dispatch) => {
      if (state.opacity === 0) {
        dispatch({ type: 'SET_OPACITY_ON' });
      }

      forceSectionNodesRelayout();
    },
    [forceSectionNodesRelayout]
  );
}
